import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { IconButton, Button, Typography } from 'shared/ui'
import { useSearchDropdownContext } from 'widgets/SearchDropdown/context/searchDropdownContext'
import styles from './styles.module.scss'

type ISearchElementProps = {
  active: boolean
}

export const SearchElement: FC<ISearchElementProps> = observer(({ active }) => {
  const store = useSearchDropdownContext()

  if (!store.hasFilters) {
    return (
      <IconButton
        active={active}
        icon={'filter'}
        variant={'icon'}
        color={'secondary'}
        size={'medium'}
        fontSize={16}
        tooltipProps={{
          label: 'Filter',
          disableInteractive: true,
          placement: 'left',
        }}
        ariaLabel='SearchElement_filter'
      />
    )
  }

  const buttonContent = (
    <div className={styles.filterButtonContent}>
      <span className={styles.divider} />
      <span className={styles.count}>
        <Typography variant={'body-xs-medium'} ariaLabel={'filtersCount'}>
          {store.filtersCount}
        </Typography>
      </span>
    </div>
  )

  return (
    <Button
      active={active || store.hasFilters}
      size='medium'
      contained='secondary'
      typeBtn='text'
      icon='filter'
      tooltipProps={{
        label: 'Filter',
        disableInteractive: true,
        placement: 'left',
      }}
      titleContent={buttonContent}
    />
  )
})
